<template>
  <el-dialog title="新建/编辑" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">

      <el-form-item label="积分分类名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入积分分类名称" />
      </el-form-item>
      <el-form-item label="页面排序" prop="orderNo">
        <el-input v-model="form.orderNo" />
        系统自动带出排序，并支持修改
      </el-form-item>
      <el-form-item label="描述" prop="described">
        <el-input v-model="form.described" placeholder="请输入商品分类描述" />
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysGoodsCategorizeApi from '@/api/goods/sysGoodsCategorize'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    parentid: null,
    name: null,
    orderNo: null,
    described: null,
    isEnable: false,
    sysGoodsAreaList: [2]
  }
  return formBean
}

export default {
  components: { ImageUpload, Treeselect },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入商品分类名称', trigger: 'blur' }],
        orderNo: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.child && !node.child.length) {
        delete node.child;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.child
      };
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(total) {
      this.resetForm()
      this.$set(this.form, 'orderNo', total + 1)
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.orderNo = params.orderNo || 0
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            sysGoodsCategorizeApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            sysGoodsCategorizeApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
